export const SECTOR = 'Sector';
//# sourceMappingURL=sector.js.map